import { createAsyncThunk } from "@reduxjs/toolkit"
import { RootThunkApi } from "../../../../app/store"
import { sendAsync } from "../../../../app/applicationSlice"
import * as S from '../../../../services/amount'
import { getSettingDetail } from "../../../../services/setting"

export const getAmountListAsync = createAsyncThunk<
  string,
  S.AmountParams,
  RootThunkApi
>('/user/user/getUserLimits', async (params, api) => {
  return sendAsync(S.AmountList(params), api)
})

export const saveUserLimitInfoAsync = createAsyncThunk<
  string,
  any,
  RootThunkApi
>('/user/user/saveUserLimitInfo', async (params, api) => {
  return sendAsync(S.saveUserLimitInfo(params), api)
})

export const getSettingDetailAsync = createAsyncThunk<
  void,
  void,
  RootThunkApi
>('/user/user/saveUserLimitInfo', async (_, api) => {
  return sendAsync(getSettingDetail(), api)
})